import { render, staticRenderFns } from "./OtherChartTable.vue?vue&type=template&id=5f993b54&"
import script from "./OtherChartTable.vue?vue&type=script&lang=js&"
export * from "./OtherChartTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports